import { createSlice, createAction } from '@reduxjs/toolkit'
import initialBotProfiles from '../config/initialBotData'
import initialBotDataJa from '../config/initialBotDataJa'

const initBotProfiles = {...initialBotProfiles}

const botProfilesReducer = createSlice({
    name: 'botprofiles',
    initialState: initialBotDataJa,
    reducers: {
        loadBotProfiles: (state, action) => {
            return action.payload
        }
    },
    extraReducers: (builder) => {
        builder
          .addCase(createAction("RESET_REDUCER"), (state, action) => {
            // console.log("user reducer receives action", action)
            state=initBotProfiles
          })
          .addDefaultCase((state, action) => {
            state = initBotProfiles
          })
    },
})
  
// Action creators are generated for each case reducer function
export const { loadBotProfiles } = botProfilesReducer.actions

export default botProfilesReducer.reducer